import { render, staticRenderFns } from "./ScoreboardList.vue?vue&type=template&id=4617150e&scoped=true&"
import script from "./ScoreboardList.vue?vue&type=script&lang=ts&"
export * from "./ScoreboardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4617150e",
  null
  
)

export default component.exports